import PropTypes from "prop-types";

import { appsConfigurationOptions } from "../../../consts";
import { withSection } from "../../../hoc";

import { GeneralTab } from "./tabs/GeneralTab";
import RolesTab from "./tabs/RolesTab";
import MarketsTab from "./tabs/MarketsTab";
import EmailTab from "./tabs/EmailTab";
import LocalisationTab from "./tabs/LocalisationTab";

import { AppManagementMenuContainer } from "../styled";

const AppsManagementMenu = ({ page, activePage, lastActiveIndex }) => {
  const pages = appsConfigurationOptions.reduce((acc, item) => {
    acc[item.title] = item.title;
    return acc;
  }, {});

  return (
    <AppManagementMenuContainer disableScroll={page === pages.LOCALISATIONS_TITLE}>
      {page === pages.GENERAL_TITLE && <GeneralTab isUpdate={activePage < lastActiveIndex} />}
      {page === pages.LOCALISATIONS_TITLE && <LocalisationTab />}
      {page === pages.MARKETS_TITLE && <MarketsTab />}
      {page === pages.ROLES_TITLE && <RolesTab />}
      {page === pages.CUSTOMIZE_EMAIL_TITLE && <EmailTab />}
    </AppManagementMenuContainer>
  );
};

AppsManagementMenu.propTypes = {
  page: PropTypes.string.isRequired,
  activePage: PropTypes.string,
  lastActiveIndex: PropTypes.func
};

export default withSection(AppsManagementMenu);
